import { render, staticRenderFns } from "./BulkEdit.vue?vue&type=template&id=79b52d5c&"
import script from "./BulkEdit.vue?vue&type=script&lang=js&"
export * from "./BulkEdit.vue?vue&type=script&lang=js&"
import style0 from "./BulkEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports